<template>
  <div id="main-page">
    <center-spinner :loading="loading" />
    <div class="auth-content">
      <div>
        <img
          src="../../../assets/img/swift-checkin-ezybuild-logo.png"
          alt=""
          class="logo"
        >
      </div>
      <v-carousel
        cycle
        hide-delimiter-background
        hide-delimiters
        height="auto"
        :show-arrows="false"
      >
        <v-carousel-item>
          <!-- <v-sheet :color="colors[i]" height="100%">
            <v-row class="fill-height" align="center" justify="center">
              <div class="text-h2">{{ slide }} Slide</div>
            </v-row>
          </v-sheet> -->
          <div class="carousel-section" />
          <div>
            <h1 class="slider-title">
              Just Tap and Scan
            </h1>
            <p class="slider-sub-title">
              Checkin on the work site is super simple now Scan the QR Code and
              Hit the Checkin
            </p>
          </div>
        </v-carousel-item>
        <v-carousel-item>
          <!-- <v-sheet :color="colors[i]" height="100%">
            <v-row class="fill-height" align="center" justify="center">
              <div class="text-h2">{{ slide }} Slide</div>
            </v-row>
          </v-sheet> -->
          <div class="carousel-section-2" />
          <div>
            <h1 class="slider-title">
              Track your timesheets
            </h1>
            <p class="slider-sub-title">
              Effortless Time Tracking, Accurate Results! Create and Track your Timesheet now.
            </p>
          </div>
        </v-carousel-item>
      </v-carousel>

      <v-btn
        class="login-button btn-style"
        color="#37474F"
        size="x-large"
        variant="flat"
        height="50"
        block
        elevation="0"
        @click="toLoginPage()"
      >
        Login
      </v-btn>
      <v-btn
        class="register-button btn-style"
        color="#E6E6E6"
        size="x-large"
        variant="flat"
        height="50"
        block
        elevation="0"
        @click="toRegisterPage()"
      >
        Register
      </v-btn>
      <br>
      <!-- <p class="or">
        OR
      </p> -->
      <!-- <v-btn
        class="device-button btn-style"
        color="#E6E6E6"
        size="x-large"
        variant="flat"
        height="50"
        block
        elevation="0"
        @click="toDeviceRegistration()"
      >
        <img
          src="../../../assets/img/devices_icon.png"
          alt=""
          class="mr-2"
        >
        Device Login
      </v-btn> -->
      <!-- <p class="mt-5 para-style">
        <font
          @click="toDeviceRegistration()"
        >
          Device Login
        </font>
      </p> -->
      <div class="copy-rights">
        <p class="copy-right-style">
          © copyright {{ year }} by Dibasys
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/app-axios';
import spinner from '../../../views/components/SpinnerCentre.vue';

export default {
  name: 'GetStartedPage',
  components: {
    'center-spinner': spinner,
  },
  data: () => ({
    loading: false,
    colors: ['indigo', 'warning', 'pink darken-2'],
    slides: ['First', 'Second', 'Third'],
    year: '',
  }),
  async mounted () {
    this.loading = true;
    localStorage.removeItem('previousSignedInAccount');
    await this.checkUserExist();
    await this.loadOnMount();
    this.loading = false;
    this.getYear();
  },
  methods: {
    getYear () {
      const d = new Date();
      this.year = d.getFullYear();
    },
    toLoginPage () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Login' });
      }, 1000);
    },
    toRegisterPage () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Register' });
      }, 1000);
    },
    async loadOnMount () {
      localStorage.removeItem('device');
      const userInfo = localStorage.getItem('user');
      if (userInfo === null) {
        return;
      }
      await axios
        .get('api/devices/me')
        .then(() => {
          const userData = JSON.parse(userInfo);
          this.$store.commit('setUserData', userData);
          this.checkUserExist();
        })
        .catch((errors) => {
          axios.post('api/devices/logout').then((response) => {
            this.$store.dispatch('logout');
            this.checkUserExist();
          });
          this.$store.dispatch('logout');
          this.checkUserExist();
        });
    },
    checkUserExist () {
      var userExist = localStorage.getItem('user');
      if (userExist !== null) {
        this.$router.push({ name: 'HomePage' });
      }
    },
    toDeviceRegistration () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'DeviceLogin' });
      }, 1000);
    },
  },
};
</script>

<style scoped>
.login-button {
  font-size: 15px;
  border-radius: 30px;
  background-color: #000 !important;
}
.register-button {
  font-size: 15px;
  color: #000;
  background-color: #fff !important;
  border: 1px solid #37474f;
  border-radius: 30px;
}
.copy-rights {
  width: 100%;
  display: flex;
  justify-content: center;
}
.copy-right-style {
  font-size: 10px;
  color: #a7a7a7;
  position: absolute;
  bottom: 5px;
}
.carousel-section {
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  height: 35vh;
  background-image: url("../../../assets/img/slide-1.png");
  background-size: cover;
  margin-bottom: 10px;
}
.slider-sub-title {
  font-size: 14px;
  text-align: center;
  color: #707070;
}
.slider-title {
  font-size: 20px;
  text-align: center;
  font-weight: 600;
}
.or {
  text-align: center;
}
.device-button {
  color: #fff;
  border-radius: 30px;
  background-color: #6a6df9 !important;
}
.logo {
  width: 150px;
  margin-bottom: 10px;
}
.v-window__prev, .v-window__next {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    position: absolute;
    margin: 0 16px;
    top: calc(50% - 20px);
    z-index: 1;
    display: none !important;
}
.carousel-section-2{
  border-radius: 5px;
  height: 35vh;
  background-image: url("../../../assets/img/slide-2.png");
  background-size: cover;
  margin-bottom: 10px;
}
</style>
,
